import { basicBaseApi } from "./basicBaseApi";
import { Methods } from '@newview/infrastructure';


export class RoadlanepointApi extends basicBaseApi {

  public get ControllerName(): any {
    return 'roadlanepoint'
  }

  /**
   * 查询列表(分页)
   * @param params
   * @returns 
   */
  public getListPage(current,size,params) {
    return this.send(params,"getListPage?current="+current+"&size="+size, Methods.GET)
  }

  /**
   * 查询所有
   * @param roadId 
   * @returns 
   */
  public getRoadLanePointByRoadId(roadId) {
    return this.send({roadId:roadId},"getRoadLanePointByRoadId", Methods.GET)
  }

  /**
   * 清空锚点数据
   * @param roadId 
   * @param roadlaneId 
   */
  public roadlanepointDelete(roadId,roadlaneId){
    return this.send({},"roadlanepointDelete?roadId="+roadId+"&roadlaneId="+roadlaneId,Methods.POST)
  }
  /**
   * 导入锚点数据
   * @param params 
   */
  public savesRoadlanepoint(params){
    return this.send(params,"savesRoadlanepoint",Methods.POST)
  }

  public getRoadLanePointDataByStone(params) {
    return this.send(params,"getRoadLanePointDataByStone", Methods.GET)
  }

  /**
   * @description 获取两个桩号之间点位
   * @param {*} params {roadId:4,targetStone:5500,endStone:6200}
   * @return {*}
   * @author: pangting
   */  
  public getRoadLanePointDataByFilter(params) {
    return this.send(params,"getRoadLanePointDataByFilter", Methods.GET)
  }


  /**
   * @description 获取车道点
   * @param {*} params {roadId:51,startOrderNo:1,endOrderNo:1000,laneId:174,gap:10}
   * @return {*}
   * @author: pangting
   */  
  getgetRoadLanePointData(params){
    return this.send(params,"getgetRoadLanePointData", Methods.GET)

  }
  

}